<template>

    <section class="flex flex-col bg-white py-8 rounded-lg my-8 shadow">

        <div class="flex flex-col lg:flex-row items-center mb-8 px-8">

            <font-awesome-icon
                class="mr-2 text-blue mb-4 lg:mb-0"
                style="width: 24px; height: 24px;"
                size="2x"
                :icon="['fas', 'bell']">
            </font-awesome-icon>

            <div class="text-3xl font-nexa text-blue mb-8 lg:mb-0"
                 style="line-height: 15px;">
                {{ __('Notifications') }}
            </div>


            <button
                class="font-bold text-white py-2 px-4 rounded-full selected ml-0 lg:ml-auto mr-0 lg:mr-4 mb-4 lg:mb-0 text-sm leading-normal xl:text-base xl:leading-[24px]"
                :class="{
                    'bg-green-600': ! onesignal_is_subscribed,
                    'bg-blue': onesignal_is_subscribed
                }"
                style="letter-spacing: 1px;"
                :key="onesignal_key"
                @click="! onesignal_is_subscribed ? onesignal_handle_click() : false">

                {{ __( onesignal_subscribe_button_text ) }}

            </button>


            <button class="border border-darker-blue font-bold text-black py-2 px-4 rounded-full selected  text-sm leading-normal xl:text-base xl:leading-[24px]"
                v-if="! is_company_defaults"
                @click="reset_to_company_defaults">
                {{ __('Reset to company defaults') }}
            </button>

        </div>


        <div class="grid w-full overflow-x-scroll"
            id="notifications_layout">

            <div class="hidden lg:block pl-8 text-gray-400 text-sm flex items-center">{{ __('Weekday') }}</div>

            <div class="hidden lg:block text-gray-400 text-sm flex items-center">{{ __('Notification clocks')}}</div>

            <div class="hidden lg:block text-gray-400 text-sm flex items-center">{{ __('Notification types')}}</div>


            <div class="hidden lg:block border-t border-gray-200"></div>

            <div class="hidden lg:block border-t border-gray-200"></div>

            <div class="hidden lg:block border-t border-gray-200"></div>


            <div class="hidden lg:block"></div>

            <div class="hidden lg:block"></div>

            <div class="hidden lg:block border-l border-gray-200"></div>


            <template v-for="day of days"
                      :key="day.id">

                <div class="pl-8 flex items-center font-bold text-xl">{{ __( day.name ) }}</div>

                <div class="flex flex-col lg:flex-row items-start lg:items-center justify-start px-8 pb-8 lg:p-0">

                    <div v-for="clock in day.clocks"
                         class="flex flex-row pb-4 lg:pb-0"
                         :key="clock.id">



                        <input type="text"
                               class="border border-gray-300 rounded-l-md"
                               :class="{
                                'ring-offset-2 ring-2 ring-offset-red border-none': is_clock_errors(clock)
                            }"
                               style="width:74px;height: 36px;"
                               :value="clock.clock"
                               :ref="`clock_${ clock.id }`"
                               autocomplete="off"
                               @blur.prevent="handle_input_clock(day, clock)"
                               @keyup.enter.prevent="handle_input_clock(day, clock)"
                        />

                        <button class="px-3 bg-blue hover:bg-red rounded-r-md mr-5"
                                style="width: 36px; height: 36px;"
                                @click="remove_clock(day, clock)">

                            <font-awesome-icon :icon="[ 'fas', 'trash' ]"
                                               size="sm"
                                               class="text-white">
                            </font-awesome-icon>

                        </button>

                    </div>


                    <button class="rounded text-white flex items-center px-3 cursor-pointer mr-5"
                            :class="{
                                'hidden': day.clocks.length >= 6
                            }"
                            style="background: linear-gradient(180deg, #3E6598 0%, #14325A 100%); width:95px; height:35px;"
                            @click.stop.prevent="add_clock(day)">

                        <span class="font-bold text-sm">{{ __('Add') }}</span>

                        <font-awesome-icon :icon="[ 'fas', 'plus' ]"
                                           size="sm"
                                           class="text-white ml-auto">
                        </font-awesome-icon>

                    </button>

                </div>

                <div class="flex flex-col lg:flex-row justify-start items-start lg:items-center border-l border-gray-200 pl-8 lg:pl-6">

                    <div class="flex mr-6 pb-4 lg:pb-0 items-center cursor-pointer"
                         @click="toggle_type(day, 'email')">

                        <div class="bg-blue text-white flex items-center justify-center mr-2"
                             style="width: 22px;height: 22px;border-radius: 4px;">

                            <font-awesome-icon
                                :class="{
                                    'hidden': ! day.is_email
                                }"
                                style="width: 14px;height: 14px;"
                                size="lg"
                                :icon="[ 'fas', 'check']">
                            </font-awesome-icon>

                        </div>

                        <div class="text-sm font-bold text-black select-none whitespace-nowrap">{{ __('Email') }}</div>

                    </div>

                    <div class="flex mr-6 items-center cursor-pointer"
                         @click="toggle_type(day,'browser')">

                        <div class="bg-blue text-white flex items-center justify-center mr-2"
                             style="width: 22px;height: 22px;border-radius: 4px;">

                            <font-awesome-icon
                                :class="{
                                    'hidden': ! day.is_browser
                                }"
                                style="width: 14px;height: 14px;"
                                size="lg"
                                :icon="[ 'fas', 'check']">
                            </font-awesome-icon>

                        </div>

                        <div class="text-sm font-bold text-black select-none whitespace-nowrap">{{ __('Browser') }}</div>

                    </div>

                </div>

            </template>

        </div>

    </section>

</template>

<script>
export default {

    props: {
        days : {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Monday',
                        clocks: [
                            {
                                id: 1,
                                clock: '12:00'
                            }
                        ],
                        is_email: true,
                        is_browser: true
                    }
                ];
            }
        },
        is_company_defaults: {
            type: Boolean,
            default: false
        }
    },


    data() {
        return {
            clock_errors: [],
        }
    },


    methods: {

        is_clock_errors(clock) {

            return !! _.find( this.clock_errors, {
                id: clock.id
            });

        },


        validate_hour(hour_string) {

            let
                hour = parseInt(hour_string)
            ;

            return hour <= 23;

        },


        validate_minute(minute_string) {

            let
                minute = parseInt(minute_string)
            ;

            return minute <= 59;

        },


        toggle_type(day,type) {                                                   let debug_id = Debug.init_method('toggle_type');

            this.$inertia.patch(
                this.route('notifications.update_day', {
                    notification_day: day.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    toggle_type: type
                },
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['days']
                        });

                    }
                }
            );

        },


        add_clock(day) {

            this.$inertia.post(
                this.route('notifications.create_clock', {
                    notification_day: day.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    clock: '12:00'
                },
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['days']
                        });

                    }
                }
            )

        },


        remove_clock(day,clock) {

            this.$inertia.delete(
                this.route('notifications.delete_clock', {
                    notification_day: day.id,
                    notification_clock: clock.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['days']
                        });

                    }
                }
            );

        },

        handle_input_clock(day, clock) {                                    let debug_id = Debug.init_method('handle_input_clock');
                                                                            Debug.log(debug_id,381,{ day, clock });
            let
                element = this.$refs[ `clock_${ clock.id }` ],
                time = element.value,
                hour,
                minute
            ;                                                               Debug.log(debug_id,384,{ element, time });


            if ( time ) {                                                   Debug.log(debug_id,389,time);

                time = time.toString();                                     Debug.log(debug_id,410,time);

                time = _.trim( time );                                      Debug.log(debug_id,410,time);

                time = _.replace( time, ':', '');        Debug.log(debug_id,412,time);

                time = _.replace( time, '.', '');        Debug.log(debug_id,414,time);

                time = _.replace( time, ',','');         Debug.log(debug_id,416,time);

                if ( time.length === 1 ) {                                  Debug.log(debug_id,418,true);

                    hour = time.charAt(0);                                  Debug.log(debug_id,420,hour);

                    minute = '00';

                }
                else if ( time.length === 2 ) {                             Debug.log(debug_id,425,true);

                    hour = time.charAt(0) + time.charAt(1);                 Debug.log(debug_id,427,hour);

                    minute = '00';

                }
                else if ( time.length === 3 ) {                             Debug.log(debug_id,432,true);

                    hour = time.charAt(0);                                  Debug.log(debug_id,434,hour);

                    minute = time.charAt(1) + time.charAt(2);               Debug.log(debug_id,436,minute);

                }
                else if ( time.length === 4 ) {                             Debug.log(debug_id,439,true);

                    hour = time.charAt(0) + time.charAt(1);                 Debug.log(debug_id,441,hour);

                    minute = time.charAt(2) + time.charAt(3);               Debug.log(debug_id,443,minute);

                }


                if (
                    ! this.validate_hour(hour)
                    || ! this.validate_minute(minute)
                    || time.length > 4
                ) {                                                         Debug.log(debug_id,451,true);

                    this.clock_errors.push(clock);

                    setTimeout(() => {

                        _.remove( this.clock_errors, { id: clock.id });

                    },2000);

                    return;

                }


                _.remove( this.clock_errors, { id: clock.id });


                hour = _.padStart(hour,2,0);

                minute = _.padStart(minute,2,0);

                time = `${ hour }:${ minute }`;

            }


            this.$inertia.patch(
                this.route('notifications.update_clock', {
                    notification_day: day.id,
                    notification_clock: clock.id,
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    time
                },
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['days']
                        });

                    }
                }
            );

        },

        reset_to_company_defaults() {

            if ( this.is_company_defaults ) {

                return;

            }


            this.$inertia.delete(
                this.route('notifications.delete_days_to_company_default', {
                    is_company_defaults: this.is_company_defaults
                }),
                {
                    preserveScroll: true,
                    onError: (error) => {

                        console.error(error);

                        this.$inertia.message('Problem');

                    },
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['days']
                        });

                    }
                }
            )

        }

    }

}
</script>

<style scoped>


#notifications_layout{
    grid-template-columns: 140px 1fr 1fr;
    grid-template-rows: 40px 1px 10px repeat(7, 60px);
}

@media (max-width: 1023px) {

    #notifications_layout{
        grid-template-columns: 1fr;
        grid-template-rows: repeat(7, 60px auto 100px);
    }

}


</style>
